// Everything the browser holds about one signed-in account. Cleared on sign-out
// so the next account on this browser starts from nothing (2026-09-27: a new
// sign-in was shown the previous account's data).
//
// Device-level choices are kept: `journal-sidebar-collapsed` is how this
// browser likes its layout, not anything about the person.
export const ACCOUNT_STORAGE_KEYS = ['token', 'userId', 'userName', 'isGuest', 'activeTab', 'sessionStart'];

/**
 * Wipes the account from storage and the query cache, then reloads, the one
 * reset that also drops every component's own state, including state added
 * after this was written.
 */
export function clearAccountFromBrowser(queryClient, reload = () => window.location.replace('/')) {
  for (const key of ACCOUNT_STORAGE_KEYS) {
    try { localStorage.removeItem(key); } catch { /* storage blocked */ }
  }
  try { sessionStorage.clear(); } catch { /* storage blocked */ }
  queryClient?.clear();
  reload();
}
